module.exports = __webpack_public_path__ + "img/no_data.f1adca8c.png";